<div id="main-wrapper" class="min-vh-100 d-flex align-items-center justify-content-center">
    <div class="row h-100 w-100">
        <div class="col-lg-12 px-0">
            <div class="pattern-design d-flex align-items-center justify-content-center">
                <div class="row d-flex flex-column justify-content-center">
                    <div class="col-lg-12 col-12 m-auto d-flex justify-content-center">
                        <div class="px-3">
                            <div class="mb-4 mt-3 mt-lg-0">
                                <img src="../../../assets/Krid/img/main-logo.svg" class="m-auto d-table logo" alt />
                            </div>
                            <div class="heading">
                                <h2>Two Factor Verification</h2>
                                <p>We have sent a verification code to <b>{{this.emailAddress}}</b></p>
                            </div>
                            <form [formGroup]="verificationForm" novalidate>
                                <div
                                    class="form-group mb-3 d-flex align-items-center justify-content-center gap-4 text-center otp-bar flex-nowrap whitespace-nowrap">
                                    <ng-otp-input (onInputChange)="onOtpChange($event)" #ngOtpInput
                                        [config]="config"></ng-otp-input>
                                </div>
                                <div class="toggle">
                                    <input type="checkbox" id="temp" formControlName="isLoginProtection" />
                                    <label for="temp">Remember for 15 days </label>
                                </div>
                                <button type="button" [disabled]="submitted == true" class="btn login-btn mt-3 mb-3"
                                    (click)="verifyCode()" [ngClass]="{ loading: isLoading }">
                                    <span *ngIf="!isLoading">{{ labelConstants.Login }}</span>
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status"
                                        aria-hidden="true"></span>
                                </button>
                                <div class="mb-3 d-flex align-items-center justify-content-center resend-link me-2">
                                    Didn’t receive the email ? <a (click)="ResendOTP()" class="ms-1 cursor fw-bold"
                                        [ngClass]="{'disabled-link': isResendDisabled}">
                                        Resend</a>
                                </div>
                            </form>
                            <div class="expire-info">
                                <ng-template [ngIf]="counter!=0" [ngIfElse]="TimeExpired">
                                    <p>Expire in <span>{{minutes}} : {{seconds}}</span></p>
                                </ng-template>
                                <ng-template #TimeExpired>
                                    <p><span class="text-danger">Time Expired</span></p>
                                </ng-template>
                            </div>
                            <div class="backtologin text-center mt-3"> <a href="javascript:void(0)"
                                    class="forgot-link float-right text-danger fw-bold" (click)="goLogin()">Back To
                                    Login</a></div>
                            <div class="rights-content">
                                <label>© {{currentYear}} ALL RIGHTS RESERVED &#124;</label>&nbsp;
                                <span>KRID</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
